export default __webpack_public_path__ + "static/logo-lndshakers-fc53514a775d83d55772583292b297e3.png";